// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x47_","rootMobile":"styles_rootMobile__1PD65"};